// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay } from "swiper";
import { Breakpoints } from "../utils/breakpoints";

export const SetupSwiper = () => {
  const contentSliders = document.querySelectorAll(
    ".slider:not(.--skip-global-setup)"
  );

  contentSliders.forEach((element) => {
    const slidesPerView = element.getAttribute("data-slides-per-view") || 1;
    const hasNavigation = element.getAttribute("data-navigation-enable");
    const hasPagination = element.getAttribute("data-pagination-enable");

    const config = {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: slidesPerView,
    };

    if (hasPagination === "") {
      config.pagination = {
        el: element.querySelector(".swiper-pagination"),
        bulletActiveClass: "current",
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
      };
    }

    if (hasNavigation === "") {
      config.navigation = {
        prevEl: element.querySelector(".swiper-button-prev"),
        nextEl: element.querySelector(".swiper-button-next"),
      };
    }

    const autoplay = element.getAttribute("data-autoplay-enable");
    const autoplayDelay = element.getAttribute("data-autoplay-delay");
    if (autoplay) {
      config.autoplay = {
        delay: Number(autoplayDelay),
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      };
    }

    const spaceBetween = element.getAttribute("data-space-between");
    if (spaceBetween === "") {
      config.spaceBetween = 24; // --ts-gutter-x
    }

    if (slidesPerView > 1) {
      const swiperBreakpoints = calculateSwiperBreakpoints(slidesPerView);
      config.breakpoints = swiperBreakpoints;
    }

    new Swiper(element, config);
  });
};

function calculateSwiperBreakpoints(slidesPerView) {
  // this will be returned
  const swiperBreakpoints = {};
  // retrieve all breakpoints, remove the largest (xl)
  const breakpointsService = new Breakpoints();
  const allBreakpoints = breakpointsService.getAll();
  delete allBreakpoints.xl;

  // calculate the step size between each breakpoint, e.g. 8 / 4 = 2 (=> xs: 1, sm: 1+2, md: 1+2+2)
  const perBreakpoint =
    slidesPerView / (Object.keys(allBreakpoints).length + 1);

  // sort the breakpoints by pixel values for the loop
  const breakpointPixelValues = Object.values(allBreakpoints).sort(
    (a, b) => a - b
  );

  let i = 0;
  // force add a breakpoint for 0px
  swiperBreakpoints[0] = { slidesPerView: 1 };
  for (const breakpointSize of breakpointPixelValues) {
    i++;
    // calculate how much slides shall be displayed
    const slidesPerBreakpoint = Math.round(1 + i * perBreakpoint);
    // add the config
    swiperBreakpoints[breakpointSize] = { slidesPerView: slidesPerBreakpoint };
  }

  return swiperBreakpoints;
}
